// extracted by mini-css-extract-plugin
module.exports = {"row":"NewCoupon_row__1038d","col":"NewCoupon_col__21tra","card":"NewCoupon_card__3fujk"};